import { gql } from '@apollo/client';

export const COMPLETE_SLIDESHOW_IA = gql`
  mutation CompleteSlideshowIA(
    $recipeIds: [String!]!
    $recipeNumber: Int!
    $slideshowSubject: NonEmptyString!
    $slideshowEditionId: UUIDv4!
    $brandKey: BrandKey!
  ) {
    completeAISlideshow(
      brandKey: $brandKey
      recipeNumber: $recipeNumber
      slideshowEditionId: $slideshowEditionId
      slideshowSubject: $slideshowSubject
      recipeIds: $recipeIds
    ) {
      status
    }
  }
`;
